<template>
  <ul class="l-breadcrumb">
    <li>
      <router-link :to="{ name: 'projects' }">
        サイト一覧
      </router-link>
    </li>
    <li v-for="item in list" :key="item.name">
      <router-link :to="item.to">
        {{ item.title }}
      </router-link>
    </li>
  </ul>
</template>
<script>
export default {
  computed: {
    list() {
      let list = [];
      if (this.$route.meta.breadcrumbs) {
        list = this.$route.meta.breadcrumbs.concat().map(item => {
          let to = {
            name: item.name
          };
          if (item.query) {
            to.query = {
              [item.query]: this.$route.query[item.query]
            };
          }
          return {
            title: item.title,
            to: to
          };
        });
      }
      list.push({
        title: this.$route.meta.title,
        to: {
          name: this.$route.name
        }
      });
      return list;
    }
  }
};
</script>
